import * as React from 'react'
import { FC } from 'react'
import { useGetDiscountCodeOnMount } from '@user/store/discountCode/hooks/useGetDiscountCodeOnMount'
import { Contents } from './Contents'
import { ReferralDiscountDetailsDrawer } from '../Details/ReferralDiscountDetailsDrawer/ReferralDiscountDetailsDrawer'
import { IDiscountCode } from '@user/store/discountCode/typings'
import { useDialogState } from '@user/utils/useDialogState'
import Alert from '@mui/material/Alert'
import LinearProgress from '@mui/material/LinearProgress'

interface Props {
  referralDiscountId: string
}

interface BannerProps {
  discountCode?: IDiscountCode
  loadingStatus: 'pending' | 'success' | 'failure' | undefined
  onOpen: () => void
}

const ErrorAlert: FC = () => (
  <Alert severity="error">Failed to load Referral Discount details</Alert>
)

const Banner: FC<BannerProps> = (props) => {
  const { discountCode, loadingStatus, onOpen } = props
  switch (loadingStatus) {
    case 'pending':
      return <LinearProgress />
    case 'failure':
      return <ErrorAlert />
    case 'success':
      return discountCode ? (
        <Contents onOpen={onOpen} referralDiscountCode={discountCode} />
      ) : (
        <ErrorAlert />
      )
    default:
      return <ErrorAlert />
  }
}

export const AppliedReferralCodeBanner: FC<Props> = (props) => {
  const { referralDiscountId } = props

  const { discountCode, loadingStatus } =
    useGetDiscountCodeOnMount(referralDiscountId)

  const [open, onOpen, onClose] = useDialogState()

  return (
    <>
      <Banner
        discountCode={discountCode}
        loadingStatus={loadingStatus}
        onOpen={onOpen}
      />
      {discountCode && (
        <ReferralDiscountDetailsDrawer
          open={open}
          onClose={onClose}
          referralDiscountCode={discountCode}
        />
      )}
    </>
  )
}
